import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";

const styles = {
	errorPopup: {},
};

const QuestionsTab = ({ t, disabled, formStatus, questionAnswersSaved, questionErrors }) => {
	return (
		<Popup
			position="bottom right"
			disabled={formStatus && questionAnswersSaved && questionErrors.length === 0}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="question circle" size="small" /> {t("subMenu.questionnaires")}
					{!disabled && (formStatus && questionAnswersSaved && questionErrors.length === 0 ? <CheckIcon /> : <WarningIcon />)}
				</span>
			}
		>
			<Popup.Header>{t("subMenu.questionWithoutResponse")}</Popup.Header>
			<Popup.Content>
				<List bulleted>
					{!questionAnswersSaved && <List.Item key={`question-not-saved`}>{t("subMenu.answerNotChecked")}</List.Item>}
					{questionErrors.map((error, index) => (
						<List.Item key={`question-${index}`}>{error}</List.Item>
					))}
				</List>
			</Popup.Content>
		</Popup>
	);
};

export default QuestionsTab;
